var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-main auth-main__reset-password" }, [
    _c(
      "main",
      {
        staticClass: "main--login",
        attrs: { id: "main", "data-page-id": "login" }
      },
      [
        _c(
          "section",
          { staticClass: "section-login" },
          [
            _c("Header", { attrs: { "is-whitelabel": _vm.isWhitelabel } }),
            _vm._v(" "),
            _c("div", { staticClass: "login-form-wrapper" }, [
              _c(
                "div",
                { staticClass: "loginv2-container p-b-20" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", {
                      staticClass: "login_logo",
                      class: { "login_logo--ringba": !_vm.isWhitelabel }
                    })
                  ]),
                  _vm._v(" "),
                  !_vm.twoFactorAuthRequired
                    ? _c("PasswordResetForm", {
                        attrs: { "action-status": _vm.actionStatus },
                        on: { "reset-password": _vm.onResetPassword }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.twoFactorAuthRequired
                    ? _c("TwoFactorForm", {
                        attrs: {
                          "back-button-description": "BACK_RESET_PASSWORD_LINK",
                          "action-status": _vm.twoFactorActionStatus
                        },
                        on: {
                          "two-factor-verify": _vm.onResetPasswordTwoFactor
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isWhitelabel ? _c("Footer") : _vm._e(),
        _vm._v(" "),
        _vm.isWhitelabel ? _c("WhitelabelFooter") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }